var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoFallback = function SvgLogoFallback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.005a3.5 3.5 0 0 0-2.09.695L7.3 6.59A3.43 3.43 0 0 0 8 4.505 3.5 3.5 0 1 0 6.595 7.3L8.7 9.41a3.5 3.5 0 1 0 2.8-1.405M2 4.505a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
  })));
};
export default SvgLogoFallback;